import { useEffect, useRef } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import { activeWorkspaceState, authState, featuresState } from "../../Recoil/RecoilState";
import { useSnackbar } from "notistack";

const TokenCheck = () => {
  const [authRecoil, setAuthRecoil] = useRecoilState(authState);
  const setActiveWorkspace = useSetRecoilState(activeWorkspaceState);
  const setFeatures = useSetRecoilState(featuresState);
  const { enqueueSnackbar } = useSnackbar();
  const isLoggingOutRef = useRef(false);

  const handleLogout = (reason = "Session expired. Please login again.") => {
    if (isLoggingOutRef.current) return;
    isLoggingOutRef.current = true;

    try {
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("expire");
      localStorage.removeItem("role");
    } catch {
      // ignore
    }

    setActiveWorkspace(null);
    setFeatures(null);
    setAuthRecoil(null);

    if (reason) {
      enqueueSnackbar(reason, { variant: "warning" });
    }
  };

  // 1. Check local token expiration timestamp periodically
  useEffect(() => {
    if (!authRecoil?.token) return;

    const checkExpiration = () => {
      const expire = authRecoil?.expire;
      if (!expire) return;

      let expireMs = 0;
      if (!isNaN(expire)) {
        const numExpire = Number(expire);
        expireMs = numExpire < 10000000000 ? numExpire * 1000 : numExpire;
      } else {
        expireMs = new Date(expire).getTime();
      }

      const now = Date.now();
      if (expireMs && now >= expireMs) {
        handleLogout("Session expired. Please login again.");
      }
    };

    checkExpiration();
    const interval = setInterval(checkExpiration, 10000);
    return () => clearInterval(interval);
  }, [authRecoil?.token, authRecoil?.expire]);

  // 2. Listen to global 401 session-expired events
  useEffect(() => {
    const onSessionExpired = () => {
      handleLogout("Invalid or expired session. Please login again.");
    };

    window.addEventListener("auth:session-expired", onSessionExpired);
    return () => window.removeEventListener("auth:session-expired", onSessionExpired);
  }, []);

  return null;
};

export default TokenCheck;
